import React, { Component } from 'react'
import StatusPageMixin from 'containers/shared/StatusPageMixin'
import Typography from '@material-ui/core/Typography'
import {connect} from 'react-redux'

export class NotFound extends StatusPageMixin(Component){
  body = () =>
    <div>
      <Typography variant='h6'>Message Sent</Typography>
      <Typography variant='body2'>We have sent a message to your mobile to start KYC verification.</Typography>
      <Typography variant='body1'>Please follow the link in the message.</Typography>
    </div>
}

export default connect()(NotFound)